import React from "react"
import { FaCode, FaSketch, FaAndroid } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "web development",
    text: `Hands on experience developing and deploying software in one or more of the following technologies - ReactJS, GatsbyJS and Restful API`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "web design",
    text: `Providing functional and responsive web designs using hand coded Html, Css, Javascript`,
  },
  {
    id: 3,
    icon: <FaAndroid className="service-icon" />,
    title: "app development",
    text: `Innovative Android Developer, Core React Native & Kotlin areas with willingness to learn and master Front-end Development`,
  },
]
